import React, { useEffect, useState } from "react";
import ReactECharts from "echarts-for-react";

const OrderStatusDistribution = ({ data = [], isMobile }) => {
  const [options, setOptions] = useState({});

  useEffect(() => {
    // Mostrar todos los orígenes enviados por el backend
    const chartData = data
      .map((item) => ({
        name: item.origen,
        value: item.count,
      }))
      .sort((a, b) => b.value - a.value);

    const colorPalette = [

      "#00BBF9",
      "#00F5D4",
      "#B8F2E6",
      "#FF9B85",
      "#E63946",
      "#457B9D",
      "#1D3557",
      "#06D6A0",
      "#118AB2",
      "#E71D36",
      "#011627",
      "#41EAD4",
      "#FF6B6B",
      "#4ECDC4",
      "#45B7D1",
      "#96CEB4",
      "#FFEEAD",
      "#D4A5A5",
      "#9B6B9E",
      "#E9C46A",
      "#2A9D8F",
      "#264653",
      "#E76F51",
      "#48BFE3",
      "#80ED99",
      "#C77DFF",
      "#F28482",
      "#2EC4B6",
      "#FF9F1C",
   
      "#4361EE",
      "#4CC9F0",
      "#72DDF7",
      "#F15BB5",
      "#FEE440",
  
      "#FDFFB6",
      "#CAFFBF",
      "#9BF6FF",
      "#BDB2FF",
      "#FFC6FF",
      "#FF006E",
      "#8338EC",
      "#FB5607",
      "#FF0A54",
      "#3A86FF",
      "#FF4D6D",
      "#7209B7",
      "#3F37C9",
      "#073B4C",
      "#89B0AE",
      "#FAD2E1",
    ];

    setOptions({
      tooltip: {
        trigger: "item",
        formatter: "{a} <br/>{b}: {c} ({d}%)",
      },
      legend: {
        orient: isMobile ? "vertical" : "horizontal",
        bottom: isMobile ? "auto" : 0,
        top: isMobile ? 300 : "auto",
        left: isMobile ? 0 : "center",
        type: "plain",
        data: chartData.map((item) => item.name),
      },
      series: [
        {
          name: "Origen de Pedidos",
          type: "pie",
          radius: ['40%', '60%'],
          center: ['50%', isMobile ? 150 : 230],
          top: 0,
          avoidLabelOverlap: false,
          itemStyle: {
            borderRadius: 10,
            borderColor: "#fff",
            borderWidth: 2,
          },
          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "15",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: false,
          },
          data: chartData,
          color: colorPalette,
        },
      ],
    });
  }, [data, isMobile]);

  return <ReactECharts option={options} style={{ height: "100%", width: "100%" }} />;
};

export default OrderStatusDistribution;
